import { render, staticRenderFns } from "./PersonSet.vue?vue&type=template&id=62b28c1b&scoped=true&"
import script from "./PersonSet.vue?vue&type=script&lang=js&"
export * from "./PersonSet.vue?vue&type=script&lang=js&"
import style0 from "./PersonSet.vue?vue&type=style&index=0&id=62b28c1b&prod&scoped=true&lang=css&"
import style1 from "./PersonSet.vue?vue&type=style&index=1&id=62b28c1b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b28c1b",
  null
  
)

export default component.exports